import { useState, useMemo } from "react";

export const useSortableData = (items, config = null) => {
  const [sortConfig, setSortConfig] = useState(config);

  const sortedItems = useMemo(() => {
    if (!sortConfig?.key) return items;

    return [...items].sort((a, b) => {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];

      if (sortConfig.key.includes("last_")) {
        aValue = aValue
          ? new Date(aValue.endsWith("Z") ? aValue : aValue + "Z").getTime()
          : 0;
        bValue = bValue
          ? new Date(bValue.endsWith("Z") ? bValue : bValue + "Z").getTime()
          : 0;
      }

      if (!aValue && bValue) return 1;
      if (aValue && !bValue) return -1;
      if (!aValue && !bValue) return 0;

      if (aValue < bValue) {
        return sortConfig.direction === "ascending" ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === "ascending" ? 1 : -1;
      }
      return 0;
    });
  }, [items, sortConfig]);

  const requestSort = (key) => {
    let direction = "ascending";

    if (sortConfig?.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    } else if (
      sortConfig?.key === key &&
      sortConfig.direction === "descending"
    ) {
      setSortConfig(null);
      return;
    }

    setSortConfig({ key, direction });
  };

  return { items: sortedItems, sortConfig, requestSort };
};
